import { Box, Button, Dialog, DialogActions, DialogContent, Grid, IconButton, Typography } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useEffect } from "react";
import { lockScroll, unlockScroll } from "../../utils/scrollLock";
import CtaButton from "../buttonWithArrow";

// ---------- component ----------
export default function AfterFormSubmit({
    open, onClose, status, message, Catalog = false
}) {
    useEffect(() => {
        if (open) lockScroll();
        else unlockScroll();

        return () => unlockScroll(); // cleanup if component unmounts
    }, [open]);

    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {
                status &&
                <>
                    <DialogContent>
                        {
                            status === 1 ?
                                <Box sx={{ position: "relative", width: 500, maxWidth: "95vw", bgcolor: "#fff", borderRadius: 4 }}>
                                    {/* close */}
                                    <IconButton onClick={onClose} sx={{ position: "absolute", top: 0, right: 0, padding: 0 }}>
                                        <CloseRoundedIcon />
                                    </IconButton>

                                    <Typography className="jura" sx={{ fontWeight: 800, fontSize: 24, textAlign: "center" }}>
                                        Your Request is Submitted
                                    </Typography>
                                    <Typography sx={{ color: "#6b7280", textAlign: "center", mt: 1, mb: 2 }}>
                                        RSL Team will contact you soon, Thanks for your patience!
                                    </Typography>
                                    <Box
                                        component="img"
                                        src={`/img/investments/commercial/objects.svg`}
                                        alt="submitted"
                                        sx={{
                                            width: "auto",
                                            height: "auto",
                                            mx: "auto",
                                            display: "flex",
                                            justifyContent: "center"
                                        }}
                                    />
                                </Box> :
                                <Grid container spacing={3} p={4}>
                                    <Grid
                                        item
                                        md={12}
                                        sx={{ position: "absolute", right: "10px", top: "-20px" }}
                                    >
                                        <CancelIcon
                                            onClick={onClose}
                                            style={{
                                                color: "#7bcbc4",
                                                cursor: "pointer",
                                                fontSize: "26px",
                                            }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={12}
                                        sx={{ display: "flex", justifyContent: "center" }}
                                    >
                                        <img
                                            src="/img/reject.png"
                                            alt="Success"
                                            width="100"
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={12}
                                        sx={{ display: "flex", justifyContent: "center" }}
                                    >
                                        <h3 style={{ fontWeight: "400", fontSize: "16px" }}>
                                            {message}
                                        </h3>
                                    </Grid>
                                </Grid>
                        }


                    </DialogContent>
                    {Catalog &&
                        <DialogActions className='m-auto mb-8' style={{ paddingBottom: "20px" }}>
                            <CtaButton
                                // variant='outlined'
                                component='a'
                                href={`${process.env.IMAGE_BASE_URL}/images/userwebsite/investor/rsl-dubai-investmentguide.pdf`}
                                download='rsl-dubai-investmentguide.pdf'
                                target='_blank'
                                label="Download Catalog"
                            />
                        </DialogActions>
                    }
                </>
            }

        </Dialog>
    );
}
